import React from 'react'

import { COLORS } from '@btime/constants'
import ListGroup from '../list/ListGroup'

const FiltersGroup = ({ children, label }) => {
  return (
    <ListGroup title={label} noMargin bgColor={COLORS.light2}>
      {children}
    </ListGroup>
  )
}

export default FiltersGroup
